import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=1e38c332&scoped=true&"
import script from "./LayoutCard.vue?vue&type=script&lang=ts&"
export * from "./LayoutCard.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=1e38c332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e38c332",
  null
  
)

export default component.exports